module.exports = __webpack_public_path__ + "static/fonts/notokr-bold.073dba1.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/views/surveys/sapporo/font/notokr-bold.woff2
// module id = Pbj0
// module chunks = 0